import { render } from "./ChatBubble.vue?vue&type=template&id=7f765a61&scoped=true"
import script from "./ChatBubble.vue?vue&type=script&lang=js"
export * from "./ChatBubble.vue?vue&type=script&lang=js"

import "./ChatBubble.vue?vue&type=style&index=0&id=7f765a61&scoped=true&lang=css"

import exportComponent from "/Users/macpc/Documents/WORK/project/Rail_transit_exper_mental_platform/源代码/实验综合平台/experimentalSynthesisUI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f765a61"]])

export default __exports__